// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IUnappliedPushInvoiceDto } from './IUnappliedPushInvoiceDto';
import {
    IUnappliedPushInvoiceDtoFromJSON,
    IUnappliedPushInvoiceDtoFromJSONTyped,
    IUnappliedPushInvoiceDtoToJSON,
    IUnappliedPushInvoiceDtoToJSONTyped,
} from './IUnappliedPushInvoiceDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageUnappliedPushInvoiceDto
 */
export interface IPageUnappliedPushInvoiceDto {
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IUnappliedPushInvoiceDto>}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    content?: Array<IUnappliedPushInvoiceDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageUnappliedPushInvoiceDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageUnappliedPushInvoiceDto interface.
 */
export function instanceOfIPageUnappliedPushInvoiceDto(value: object): value is IPageUnappliedPushInvoiceDto {
    return true;
}

export function IPageUnappliedPushInvoiceDtoFromJSON(json: any): IPageUnappliedPushInvoiceDto {
    return IPageUnappliedPushInvoiceDtoFromJSONTyped(json, false);
}

export function IPageUnappliedPushInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageUnappliedPushInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IUnappliedPushInvoiceDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageUnappliedPushInvoiceDtoToJSON(json: any): IPageUnappliedPushInvoiceDto {
    return IPageUnappliedPushInvoiceDtoToJSONTyped(json, false);
}

export function IPageUnappliedPushInvoiceDtoToJSONTyped(value?: IPageUnappliedPushInvoiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IUnappliedPushInvoiceDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

